<div class="d-block position-absolute top-0 start-0 w-100 h-100 overflow-hidden">
    <!-- Sidebar -->
    <div class="sidenav d-none d-md-block"></div>

    <!-- Main Content -->
    <div class="main bg-white">
      <div class="login-form-container">
        <img src="./assets/images/SmartDukaan_Logo_Transparent.png" style="width: 114px; " loading="lazy">
        <div class="login-form mt-3">
          <form (submit)="register()">
            <!-- First Name -->
            <div class="form-group">
                <label for="firstName" class="fs-12 grey-color pb-1">Enter your First Name <span class="brand-color">*</span></label>
              <input type="text" id="firstName" class="form-control" placeholder="First Name" [(ngModel)]="user.firstName" required>
            </div>

            <!-- Last Name -->
            <div class="form-group">
              <label for="lastName" class="fs-12 grey-color pb-1">Enter your Last Name <span class="brand-color">*</span></label>
              <input type="text" id="lastName" class="form-control" placeholder="Last Name" [(ngModel)]="user.lastName" required>
            </div>

            <!-- Email -->
            <div class="form-group">
              <label for="email" class="fs-12 grey-color pb-1">Enter your Email Address<span class="brand-color">*</span></label>
              <input type="email" id="email" class="form-control" placeholder="Email Address" [(ngModel)]="user.email" required
                pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" #email="ngModel">
              <div [hidden]="email.valid || email.pristine" class="text-danger small">
                <div [hidden]="!email.hasError('required')">Email is required</div>
                <div [hidden]="!email.hasError('pattern')">Invalid email format</div>
              </div>
            </div>

            <!-- Password -->
            <div class="form-group">
                <label for="password" class="fs-12 grey-color pb-1">Create Password <span class="brand-color">*</span></label>
              <input type="password" id="password" class="form-control" placeholder="Password" [(ngModel)]="user.password" required>
            </div>
            <p>
              <span style="font-size:13px;color:#f67575;">
                Your password must be at least 8 characters including a lowercase letter, an uppercase letter, and a number
              </span>
            </p>
            <!-- Submit Button -->
            <div class="d-grid mt-4">
              <button type="submit" class="btn btn-black">Register</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
